import { render, staticRenderFns } from "./InseminationsByPeriodModal.vue?vue&type=template&id=0bf5d5ed"
import script from "./InseminationsByPeriodModal.vue?vue&type=script&lang=js"
export * from "./InseminationsByPeriodModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports